'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { OLAF } from 'HubStyleTokens/colors';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import { AVATAR_SIZES, AVATAR_TYPES } from '../../Constants';
const ContentHolder = styled('div').withConfig({
  displayName: "AvatarContentHolder__ContentHolder",
  componentId: "msh473-0"
})(["align-items:center;border-radius:", ";box-sizing:border-box;color:", ";display:flex;font-size:initial;", " height:", ";overflow:hidden;position:relative;width:", ";"], props => AVATAR_TYPES[props.type] === AVATAR_TYPES.productId ? '3px' : '50%', OLAF, props => props._isListReversed && `border: 2px solid ${OLAF};`, props => props.size && props.size !== AVATAR_SIZES.responsive ? `${AVATAR_SIZES[props.size]}px` : 'inherit', props => props.size && props.size !== AVATAR_SIZES.responsive ? `${AVATAR_SIZES[props.size]}px` : '100%');

const AvatarContentHolder = props => {
  const {
    href,
    children,
    size,
    type,
    _isListReversed
  } = props;
  const avatarWidth = size === AVATAR_SIZES.responsive ? '100%' : `$[size}`;
  const avatarHeight = size === AVATAR_SIZES.responsive ? '' : `$[size}`;

  if (href) {
    return /*#__PURE__*/_jsx(UIButton, {
      style: {
        width: avatarWidth,
        height: avatarHeight
      },
      use: "unstyled",
      href: href,
      children: /*#__PURE__*/_jsx(ContentHolder, {
        type: type,
        _isListReversed: _isListReversed,
        size: size,
        children: children
      })
    });
  }

  return /*#__PURE__*/_jsx(ContentHolder, {
    type: type,
    _isListReversed: _isListReversed,
    size: size,
    children: children
  });
};

AvatarContentHolder.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(AVATAR_SIZES)),
  type: PropTypes.oneOf(Object.keys(AVATAR_TYPES)),
  _isListReversed: PropTypes.bool
};
export default AvatarContentHolder;